const Devtools = () => {
  return <></>;
};

export default Devtools;
